/**
 * Matches inapp_external activity covers to the associated discovery-react activity background color
 * so that the handoff is seamless.
 *
 * Keep in sync with discovery-react's src/components/shared/components/activityBackgrounds.js and the
 * inline script in its public/index.html.
 *
 * An activity with no entry here gets no cover.
 */
export const ACTIVITY_COVER_COLORS = {
  'my-year': '#018293',
  'my-name': '#50367c',
  'famous-relatives-new': '#ca3a59',
  'salt-lake-temple': '#e7e8df',
}

export const getActivityCoverColor = (visibleId) => ACTIVITY_COVER_COLORS[visibleId] ?? null

/**
 * Text colour that stays legible on a given cover.
 *
 * Derived rather than registered per activity, so the value kept in sync with discovery-react stays a
 * single hex each.
 */
const relativeLuminance = (hex) => {
  const channels = [1, 3, 5].map((start) => Number.parseInt(hex.slice(start, start + 2), 16) / 255)
  const linear = (value) => (value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4)
  const [red, green, blue] = channels.map(linear)
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

export const readableTextColor = (background) => {
  try {
    return relativeLuminance(background) > 0.4 ? '#1b1b1b' : '#ffffff'
  } catch {
    return '#ffffff'
  }
}
